import { render, staticRenderFns } from "./tagSearch.vue?vue&type=template&id=2d8c680b&scoped=true"
import script from "./tagSearch.vue?vue&type=script&lang=js"
export * from "./tagSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c680b",
  null
  
)

export default component.exports